import { render, staticRenderFns } from "./ClientTags.vue?vue&type=template&id=5271dc00&scoped=true&"
import script from "./ClientTags.vue?vue&type=script&lang=js&"
export * from "./ClientTags.vue?vue&type=script&lang=js&"
import style0 from "./ClientTags.vue?vue&type=style&index=0&id=5271dc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271dc00",
  null
  
)

export default component.exports